import { defineComponent as _defineComponent } from 'vue'
import { toRef as _toRef } from 'vue';

import SaveSearchButton from '@/modules/common/SaveSearch/SaveSearchButton.vue';
import SaveSearchSelector from '@/modules/common/SaveSearch/SaveSearchSelector.vue';
import useSaveSearch from '@/modules/common/SaveSearch/saveSearch';
import type { Location } from 'vue-router';

interface FilterResetProps {
  filterQuantity: number
  searchDomain?: string
}

interface FilterResetEmits {
  (e: 'reset'): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Filter-Reset',
  props: {
  filterQuantity: null,
  searchDomain: { default: '' }
},
  emits: ["reset"],
  setup(__props, { emit }) {

const props = __props;




const __$temp_1 = (useSaveSearch(props.searchDomain)),
  deleteSearch = _toRef(__$temp_1, 'deleteSearch'),
  hasSearches = _toRef(__$temp_1, 'hasSearches'),
  items = _toRef(__$temp_1, 'items'),
  selectedSearch = _toRef(__$temp_1, 'selectedSearch'),
  saveSearch = _toRef(__$temp_1, 'saveSearch'),
  resetSelectedSearch = _toRef(__$temp_1, 'resetSelectedSearch');;

const handleDelete = (id: string) => {
  deleteSearch.value(props.searchDomain, id);
};

const handleSave = (name: string, query: Location['query']) => {
  saveSearch.value(name, query);
};

const handleReset = () => {
  emit('reset');
  resetSelectedSearch.value();
};


return { __sfc: true,emit, props, __$temp_1, deleteSearch, hasSearches, items, selectedSearch, saveSearch, resetSelectedSearch, handleDelete, handleSave, handleReset, _toRef, SaveSearchButton, SaveSearchSelector, useSaveSearch }
}

})